import React from "react";
import { getVarsoUrl } from "../../../../common/helpers/helpers";
import ComponentPanel from "../../../../components/atoms/ComponentPanel/ComponentPanel";
import EBIGene2PhenotypeContent from "./EBIGene2PhenotypeContent";
import withErrorGuard from "../../../../HOC/withErrorGuard";
import { EBIGene2PhenotypeType } from "../../../../components/componentTypes/EBIGene2PhenotypeType";
import HelperText from "../../../../components/atoms/HelperText";

const EBIGene2Phenotype = ({ data }) => {
  if (Object.keys(data || {}).length === 0) return null;
  if (!data?.items || data?.items?.length === 0) return null;

  return (
    <div
      className="varsome-result-fixed"
      data-testid="ebi-gene-2-phenotype-component"
    >
      <div className="varsome-container varsome-container__basic">
        <ComponentPanel
          title="EBI Gene2Phenotype"
          version={data?.version}
          url={getVarsoUrl("https://www.ebi.ac.uk/gene2phenotype")}
          helperPopup={<HelperText fieldDescriptionKey="EBI Gene2Phenotype" />}
          content={
            data?.items && (
              <div className="varsome-inner-container">
                <EBIGene2PhenotypeContent items={data?.items} />
              </div>
            )
          }
        />
      </div>
    </div>
  );
};

EBIGene2Phenotype.propTypes = {
  data: EBIGene2PhenotypeType,
};

EBIGene2Phenotype.defaultProps = {
  data: {},
};

export default withErrorGuard(
  EBIGene2Phenotype,
  "EBIGene2Phenotype",
  "EBIGene2Phenotype"
);
